import React, { useState } from 'react'
import { Modal, Space, Button, Row, Col, Typography, Table, Flex, Image, message } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import moment from 'moment'

const { Text, Title } = Typography
const JobViewModal = ({ visible, onClose, view }) => {

    const columns = [
        {
            title: 'Job',
            dataIndex: 'job',
            width: 150,
        },
        {
            title: 'Detail',
            dataIndex: 'detail',
            width: 150,
        },
    ];
    const data = [
        {
            key: '1',
            job: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Service</Text>
                <Flex gap={5}>
                    <Text>{view?.service?.name}</Text>
                </Flex>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Organization</Text>
                <Text>{view?.organizationName}</Text>
            </Space>,
        },
        {
            key: '2',
            job: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Location</Text>
                <Text>
                    {view?.location}
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Budget</Text>
                <Text>
                    {view?.budget}
                </Text>
            </Space>,
        },
        {
            key: '3',
            job: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Date</Text>
                <Text>
                    {
                        moment(view?.date).format('YYYY-MM-DD')
                    }
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Status</Text>
                {view?.status === 1 ? (
                    <Text className='active fs-12 badge-cs'>Active</Text>
                ) : (
                    <Text className='inactive fs-12 badge-cs'>Inactive</Text>
                )
                }
            </Space>,
        },
        {
            key: '4',
            job: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Description</Text>
                <Text>
                    {view?.description}
                </Text>
            </Space>,
        },
    ];
    return (
        <div>
            <Modal
                width={700}
                title={null}
                className='shadow-c modal-cs'
                open={visible}
                onOk={onClose}
                onCancel={onClose}
                closeIcon={false}
                centered
                footer={
                    <Space style={{ justifyContent: "end" }} className="w-100">
                        <Button
                            onClick={onClose}
                            block
                            type="primary"
                            className='btnsave text-white'
                        >
                            Cancel
                        </Button>
                    </Space>
                }
            >
                <Flex align='center' justify='space-between' className='header-modal mb-3'>
                    <Space>
                        <Text strong>Job Details View</Text>
                    </Space>
                    <Button className='bg-transparent border0 p-0 ' onClick={onClose}>
                        <CloseOutlined className='text-gray' />
                    </Button>
                </Flex>
                <Flex justify="center">
                    <Image
                        src={view?.image}
                        preview={false}
                        width={150}
                        height={150}
                        style={{ objectFit: "cover" }}
                        className="radius-12"
                    />
                </Flex>
                <div
                    className='content-modal pb-2'
                >
                    <Row gutter={[24, 24]}>
                        <Col span={24}>
                            <Table
                                size='large'
                                columns={columns}
                                dataSource={data}
                                scroll={{ x: 600 }}
                                className='pagination'
                                showSorterTooltip={false}
                                rowHoverable={false}
                                showHeader={false}
                                pagination={false}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    )
}

export { JobViewModal }